import { A, useNavigate, useParams } from '@solidjs/router'
import { getAssetUrl } from '/web/shared/util'
import { chatStore, settingStore } from '/web/store'
import GenerateButton from '/web/shared/aifans/model/buttons/GenerateButton'
import ChatModelTraits from './ChatModelTraits'

const ChatRightNav = (props: any) => {
  const params = useParams()
  const nav = useNavigate()

  const chats = chatStore((s) => ({
    ...(s.active?.chat._id === params.id ? s.active : undefined),
  }))

  return (
    <div class="flex h-[calc(100vh-118px)] flex-col overflow-x-hidden md:h-[calc(100vh-82px)]">
      <div class="relative h-[488px] w-screen flex-shrink-0 overflow-hidden md:w-[406px]">
        <button
          onClick={() => {
            settingStore.rightNav(false)
            settingStore.rightNavMobile()
          }}
          class="absolute left-0 top-2 z-50 flex items-center justify-center gap-1 p-3 text-xs md:hidden"
        >
          <img src="/images/icons/arrow-back.svg" class="h-5 w-5" />
          BACK
        </button>
        {chats.char?.avatar && (
          <img
            class="absolute h-full w-full object-cover"
            src={getAssetUrl(chats.char?.avatar)}
            alt="user"
          />
        )}
      </div>
      <div class="border-b border-b-cosplay-gray-100 px-8 py-[18px]">
        <div class="flex flex-row items-end">
          <h2 class="mr-3 font-clash text-[26px] font-bold leading-[30px]">{chats.char?.name}</h2>
          <div class="flex-shrink-0">
            <A href={`/model/${chats.char?._id}`} class="text-sm text-cosplay-red">
              View Full Profile
            </A>
          </div>
        </div>
        <div class="mt-0">
          <span class="text-[15px]">Model - </span>
          <span class="text-[15px] text-cosplay-gray-100">{chats.char?.realName}</span>
        </div>
        <div class="mt-4">
          <GenerateButton
            title="GENERATE IMAGE"
            centered
            onClick={() => nav(`/generate-image/${chats.char?._id}`)}
          />
        </div>
      </div>
      <div>
        <ChatModelTraits
          personality={chats.char?.personality}
          occupation={chats.char?.occupation}
          hobbies={chats.char?.hobbies}
          relationship={chats.char?.relationship}
          bodyType={chats.char?.bodyType}
          age={chats.char?.age}
          butt={chats.char?.butt}
          hair={chats.char?.hair}
          breasts={chats.char?.breasts}
          ethnicity={chats.char?.ethnicity}
        />
      </div>
    </div>
  )
}
export default ChatRightNav
